import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';
import type { ContactItem } from '@shared/types/contacts';

type ClientContactModal = {
  isOpen: boolean;
  contactData?: ContactItem;
  type?: 'create' | 'edit';
  clientId?: number;
};

export const useClientContactModal = () => {
  const {
    data: state,
    doRemoveStorageData,
    doSetStorageData,
  } = useSaveData<ClientContactModal>('clientContactModalState');

  const openClientContactModal = useCallback(
    (props: Omit<ClientContactModal, 'isOpen'>) => doSetStorageData({ ...props, isOpen: true }),
    [doSetStorageData]
  );

  return {
    state,
    openClientContactModal,
    closeClientContactModal: doRemoveStorageData,
  };
};
